<script setup lang="ts">
import { computed, ref, watch, defineEmits, nextTick  } from 'vue';
const props = defineProps({
  modelValue: {type:[Number, String], default:''},
  size: {type:String, default:'default'}
})

// const { value } = toRefs(props) 
const _percent = ref(0)
// props.value
const onUpdateVal = ()=>{
  let num = _percent.value
  let value = `${num}%`
  emit('update:modelValue', value) 
  emit('change', value)
}
const emit = defineEmits(['update:modelValue','change']);
watch(()=>props.modelValue, (val:any) => {
  try{
    let value = parseFloat(val.replace('%', ''))
    if(!isNaN(value)){
      _percent.value = value
    }
  }catch(error){}
}, {immediate: true})
</script>
<template>
<el-input-number 
  v-model="_percent" 
  @change="onUpdateVal"
  :controls="false" :size="size">
  <template #suffix>
    <span>%</span>
  </template>
</el-input-number>
</template>

<style lang="less" scoped>
</style>